// extracted by mini-css-extract-plugin
export default {"container":"MessageClip_container__N4shQ","slider":"MessageClip_slider__Ymh0B","label":"MessageClip_label__grnMo","customLabel":"MessageClip_customLabel__oyCTK"};